import "./Recreational.scss";
import { Autocomplete, Card, Checkbox, Chip, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import { Field, Formik, useFormikContext } from "formik";
import * as yup from "yup";
import {
  API_RESPONSE,
  I18_TRANSLATION_COMMON,
  MODES,
  NUMBER_CONSTANTS,
  PROFESSIONAL_DETAILS,
  ROUTES,
  STORAGE_KEYS,
  TEACHING_MODE,
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
} from "../../../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import { ReactNode, useEffect, useState } from "react";
import {
  ERROR_MESSAGES,
  REGEX,
  REGISTRATION_ERRORS,
} from "../../../../../Utilities/Constants/Validations";

import API_END_POINTS from "../../../../../Utilities/Constants/ApiEndpoints";
import plus from "../../../../../../Assets/Registration/plus.svg";
import { toast } from "react-toastify";

import { axiosInstance } from "../../../../../Services/Interceptor/Interceptor";
import { GetSessionStorageData, nullUndefinedEmptyCheck, numberOnly } from "../../../../../Services/Helpers/Helper";
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { useLocation } from "react-router-dom";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CategoryValidationDialog from "../../../../../Shared/CategoryValidationDialog/CategoryValidationDialog";

const Recreational = (props: any) => {

  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [selectedSubjects, setSelectedSubjects]: any = useState(" ");
  const [selectedSubjectsList, setSelectedSubjectsList]: any = useState(" ");
  const [experienceErrText, setExperienceErrText] = useState(false);
  const [modeOfTeching, setModeOfTeaching] = useState<any>(`${NUMBER_CONSTANTS.TWO}`);
  const [mode, setMode] = useState(MODES.EDIT);
  const [subjectList, setSubjectList]: any = useState([]);
  const [subjectListCopy, setSubjectListCopy]: any = useState([]);
  const [skillsList, setSkillsList]: any = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [initialRender, setInitialRender] = useState(API_RESPONSE.TRUE);
  const [skillsTouched, setSkillsTouched] = useState<any>(API_RESPONSE.FALSE);
  const [formSubmitted, setFormSubmitted] = useState(API_RESPONSE.FALSE);
  const [subjectFormSubmitted, setSubjectFormSubmitted] = useState(API_RESPONSE.FALSE)
  const [expSubject, setExpSubject]: any = useState([]);
  const [personalDetail, setPersonalDetail]: any = useState({});
  const [courses, setCourses]: any = useState([]);
  const [userType, setuserType]: any = useState("");
  const [expectedFee, setExpectedFee] = useState('');
  const [experience, setExperience] = useState('');
  // const [gradesList, setGradesList]: any = useState([]);
  const [highestQulaificationList, setHighestQualificationList] = useState<any>([]);
  const [degreeList, setDegreeList] = useState<any>([]);
  const [enableDegree, setEnableDegree] = useState(false);
  const [editable, setEditable] = useState(API_RESPONSE.TRUE);

  const [categoryValidationDetails, setCategoryValidationDetails] = useState<any>("")
  const [categoryValidationMessage, setCategoryValidationMessage] = useState<any>("")
  const [open, setOpen] = useState<boolean>(false)

  const handleClose = () => {
    setOpen(false)
  }

  const location = useLocation();
  const [initialValues, setInitialValues] = useState({
    [PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION]: "",
    // [PROFESSIONAL_DETAILS.SUBJECT]: "",
    // [PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED]: "",
    [PROFESSIONAL_DETAILS.TEACHING_MODE]: '',
    //  [PROFESSIONAL_DETAILS.EXPERIENCE]: "",
    [PROFESSIONAL_DETAILS.SPECIALIZATIONS]: "",
  });

  let UNITED_ARAB = 'United Arab Emirates';

  const [country, setCountry] = useState<string>(UNITED_ARAB);
  const [region, setRegion] = useState<any>([])
  const [locations, setLocations] = useState<{ state: string; latitude: number; longitude: number, radius: number }[]>([]);

  const cityOptions: string[] = [
    'Dubai',
    'Abu Dhabi',
    'Sharjah',
    'Ajman',
    'Al Ain',
    'Fujairah',
    'Ras Al-Khaimah',
    'Umm Al-Quwain',
  ];

  useEffect(() => {
    getHighestQualification(0);
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));

  }, []);

  useEffect(() => {

    if (userType === `${NUMBER_CONSTANTS.NINE}`) {
      getCategoriesList(API_END_POINTS.GET_RECREATIONAL);
      getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS);
    }

  }, [userType]);

  useEffect(() => {
    if (personalDetail)
      setDetails();
  }, [personalDetail]);

  const getHighestQualification = (type: number) => {
    axiosInstance.get(API_END_POINTS.HIGHEST_QUALIFICATION_LIST + `?parent_id=${type}`).then((response: any) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {

        if (type === 0) {
          setHighestQualificationList([...response.data.result.data]);
          setDegreeList([]);
        } else {
          setDegreeList([...response.data.result.data]);
          response.data.result.data?.length > 0 ?
            setEnableDegree(true) :
            setEnableDegree(false);
        }
      }
    })
  };



  const setDetails = () => {
    setInitialValues({
      [PROFESSIONAL_DETAILS.DEGREE]: personalDetail.degree,
      [PROFESSIONAL_DETAILS.HIGHER_EDUCATION]: personalDetail.high_education,
      [PROFESSIONAL_DETAILS.DEGREE_SUBJECT]: personalDetail.degree_subject,
      // [PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION]: personalDetail.trainer_qualification,
      // [PROFESSIONAL_DETAILS.SUBJECT]: "",
      //   [PROFESSIONAL_DETAILS.CURRICULAM]: personalDetail.curriculum,
      // [PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED]:personalDetail.activities_offered,
      [PROFESSIONAL_DETAILS.TEACHING_MODE]: `${NUMBER_CONSTANTS.TWO}`,
      // [PROFESSIONAL_DETAILS.EXPERIENCE]: personalDetail.experience,
      [PROFESSIONAL_DETAILS.SPECIALIZATIONS]: "",
    });
    setSelectedSubjects(personalDetail.activities_and_experience);
    setExpSubject(personalDetail.activities_and_experience ? personalDetail.activities_and_experience : []);
    personalDetail.specializations ? setSkillsList(personalDetail.specializations) : setSkillsList([]);
    //   personalDetail.subject_and_experience? setExpSubject(personalDetail.subject_and_experience) : setExpSubject([]);
    //   setModeOfTeaching(personalDetail.teaching_mode);
  }



  const getRegistrationDetail = (API_END_POINT: any) => {
    axiosInstance.get(API_END_POINT).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setEditable((prev) => response.data.result.data[NUMBER_CONSTANTS.ZERO]?.status === "approved" ? API_RESPONSE.FALSE : API_RESPONSE.TRUE);
        setPersonalDetail(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
      }
    })
  }

  const getCategoriesList = (API_POINT: any) => {
    axiosInstance.get(API_POINT).then((response: any) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setSubjectList(response.data.result.data);
        setSubjectListCopy(response.data.result.data);
      }
    });
  };

  /*geting seteled category detailes */
  const getValidateCategoryDetailes = () => {
    axiosInstance.get(API_END_POINTS.MANAGE_CATEGORY)
      .then((res: any) => {
        if (res.data[API_RESPONSE.STATUS]) {
          setCategoryValidationDetails(res.data.result.data)
          setOpen(true)
        }
      })
  }

  /*Category validation */
  const validateCategory = () => {
    let payload = {
      "category_id": +selectedSubjects.id || null
    }
    axiosInstance.post(API_END_POINTS.MANAGE_CATEGORY, payload)
      .then(
        (res: any) => {
          if (!res.data.result.data.status) {
            getValidateCategoryDetailes()
            setCategoryValidationMessage(res.data.message)
          } else {
            onAddSubjects()
          }
        }
      ).catch(() => {
      })
  }

  /*undate or accept commision change */
  const putValidationCategory = () => {
    let payload = {
      "id": categoryValidationDetails?.id,
      "category_id": categoryValidationDetails?.category_id,
      "teach_service_provider_id": categoryValidationDetails?.teach_service_provider,
      "status": "accepted"
    }
    axiosInstance.put(API_END_POINTS.MANAGE_CATEGORY, payload)
      .then((res: any) => {
        if (res.data[API_RESPONSE.STATUS]) {
          onAddSubjects()
          handleClose()
        }
      })
  }


  const degreeValidation = (enableDegree: Boolean, errorMessage: any) =>
    enableDegree
      ? yup.string().required(errorMessage)
      : yup.string();

  const personalValidationSchema = yup.object({

    // [PROFESSIONAL_DETAILS.HIGHER_EDUCATION]: yup
    // .string()
    // .required(REGISTRATION_ERRORS.HIGHER_EDUCATION),

    // [PROFESSIONAL_DETAILS.DEGREE]:  degreeValidation(enableDegree, REGISTRATION_ERRORS.DEGREE),

    // [PROFESSIONAL_DETAILS.DEGREE_SUBJECT]: degreeValidation(enableDegree, REGISTRATION_ERRORS.DEGREE),

    [PROFESSIONAL_DETAILS.TEACHING_MODE]: yup
      .string()
      .required(REGISTRATION_ERRORS.MODE_OF_TEACHING),

    [PROFESSIONAL_DETAILS.SPECIALIZATIONS]: yup
      .array()
      .of(yup.string()),
  });


  /* Update subject state */
  const onSelectSubjects = (event: any) => {
    setSelectedSubjectsList(event.target.value);
    event.target.value.id ?
      setSelectedSubjects(event.target.value) :
      setSelectedSubjects(" ")
  };

  const onChangeExperience = (event: any) => {
    if (event.target.value <= 100 && selectedSubjectsList?.min_experience) {
      setExperience(event.target.value);
      if (event.target.value >= selectedSubjectsList?.min_experience) {
        setExperienceErrText(false)
      } else {
        setExperienceErrText(true)
      }
    }
  };

  useEffect(() => {
  }, [subjectList])

  useEffect(() => {
    let keyArr: any = [];
    expSubject?.forEach((obj: any) => {
      keyArr.push(obj.id);
    });
    setCourses(keyArr);
    userType === `${NUMBER_CONSTANTS.FOUR}` ?
      setSubjectList(subjectListCopy.filter((item: any, index: any) => !keyArr.includes(item.id))) :
      setSubjectList(subjectListCopy.filter((item: any, index: any) => !keyArr.includes(item.id)))
    setExperience('');
    setExpectedFee('');
    setSelectedSubjects(' ');

  }, [expSubject, subjectListCopy])

  const onAddSubjects = () => {
    setSubjectFormSubmitted(API_RESPONSE.TRUE)
    if (selectedSubjects && experience !== '' && expectedFee != '' && selectedSubjects.id && !experienceErrText) {
      setExpSubject([...expSubject, {
        id: selectedSubjects.id,
        activity: selectedSubjects.category_name,
        experience: experience,
        arabic_name: selectedSubjects.arabic_category_name,
        expected_fee: expectedFee,
        course_mode: TEACHING_MODE.OFFLINE,
        location: locations
      }]);
      setSubjectFormSubmitted(API_RESPONSE.FALSE)
    } else {
      if (selectedSubjects.trim("")) {
        setSelectedSubjects(' ');
      }
    }


  };

  const onEditInput = (index: any, fee: any) => {
    let payload = expSubject;
    payload[index].expected_fee = fee;
    setExpSubject([...payload])
  };
  const onEditSubject = (index: any) => {
    let payload = expSubject;
    payload[index].isEdit = payload[index].isEdit ?
      payload[index].isEdit === API_RESPONSE.TRUE ? API_RESPONSE.FALSE : API_RESPONSE.TRUE :
      payload[index].isEdit = API_RESPONSE.TRUE;
    setExpSubject([...payload])
  };



  /* Deleting tag from taglist */
  const handleDelete = (i: any) => () => {
    setSkillsList(skillsList.filter((item: any) => item !== skillsList[i]));
  };


  /* Deleting subjects from list */
  const handleDeleteSubject = (index: any) => {
    setExpSubject(expSubject.filter((course: any, i: any) => course.id !== index));


  };

  /* Handling enter keypress */
  const handleKeyPress = (event: any) => {
    if (
      event.key === VALIDATION_CONSTANT.KEY_TYPE &&
      nullUndefinedEmptyCheck(event.target.value.trim())
    ) {
      onAddTag();
    }
  };

  const onAddTag = () => {
    if (
      nullUndefinedEmptyCheck(currentTag.trim()) &&
      skillsList?.filter((item: any) => item === currentTag)?.length === NUMBER_CONSTANTS.ZERO
    ) {
      setSkillsList([...skillsList, currentTag]);
    } else {
      if (nullUndefinedEmptyCheck(currentTag.trim())) toast.error(ERROR_MESSAGES.SPECIALIZATION_VALIDATION);
    }
    setCurrentTag("");
  };

  /* Setting current input value */
  const setInputValue = (e: any) => {
    /* if (
      REGEX.ENGLISH_INPUT_VALIDATION.test(e.target.value) &&
      !/[0-9.]/.test(e.key)
    ) { */
    setCurrentTag(e.target.value);
    // }
  };

  /* Submit API call */
  const onSubmitData = (payload: any) => {
    payload.specializations = skillsList;
    payload.teaching_mode = `${NUMBER_CONSTANTS.TWO}`;
    payload.activities_and_experience = expSubject;
    if (/* skillsList?.length > 0 && */ expSubject.length > 0) {
      let END_POINT = location.pathname === ROUTES.PROFILE ? API_END_POINTS.TRAINER_PROFILE_UPDATE : API_END_POINTS.PERSONAL_PROFESSIONAL_REGISTER;
      axiosInstance.put(END_POINT + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.TWO, payload).then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          if (location.pathname !== ROUTES.PROFILE)
            onNavigate(NUMBER_CONSTANTS.THREE);
        }
      })
    } /* else {
      if (skillsList?.length > 0 && expSubject.length === 0) {
        toast.error(REGISTRATION_ERRORS.ADD_ACTIVITY)
    }
    } */

  };

  /* Navigate call */
  const onNavigate = (state: any) => {
    props.setActiveStatus(state);
  };


  const getDegreeList = (value: any) => {
    let listIndex = highestQulaificationList.findIndex((data: any, index: number) => {
      return data.highest_education === value;
    });
    if (listIndex >= 0)
      getHighestQualification(highestQulaificationList[listIndex]?.id)

  };

  const handleRegionChange = async (event: any, newValue: string[]) => {
    setRegion(newValue);

    // Fetch coordinates for each selected region
    const promises = newValue.map((region) =>
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          country === UNITED_ARAB ? region : country
        )}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
      )
        .then((response) => response.json())
        .then((data) => {
          const { lat, lng } = data?.results[0]?.geometry?.location || {};
          return { state: region, latitude: lat, longitude: lng, radius: 15 };
        })
    );

    // Wait for all fetches to complete
    const resolvedLocations = await Promise.all(promises);
    setLocations(resolvedLocations);
  };
  const radiusHandleChange = (event: any) => {
    const radius = event?.target?.value;

    setLocations((prelocation) =>
      prelocation?.map((location: any) => ({
        ...location,
        radius: radius,
      }))
    );
  };
  return (
    <div className="row details-wrapper">
      <div className="col-md-12">
        <Card className="pd-card-wrapper">
          <Formik
            initialValues={initialValues}
            validationSchema={personalValidationSchema}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
              onSubmitData(values);
            }}
          >
            {(formik: any) => {
              return (
                <div>
                  <div className="row row-wrap">
                    {/* <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">
                          {t("Educational Qualification")}
                        </label>
                        <Field
                          name={PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION}
                          className="email-input"
                          placeholder={t(`Trainer Qualification`)}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION,
                              e.target.value
                            );
                          }}
                        />
                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION] &&
                            formik.errors[PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.TRAINER_QUALIFICATION]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div> */}
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Highest Level of Education")}
                        </label>
                        <Field
                          as="select"
                          name={PROFESSIONAL_DETAILS.HIGHER_EDUCATION}
                          className="email-input"
                          placeholder={t("Ex: BE")}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              PROFESSIONAL_DETAILS.HIGHER_EDUCATION,
                              e.target.value
                            );
                            getDegreeList(e.target.value);
                          }}
                          disabled={editable ? false : true}
                        >
                          <option value="">Please select highest qualification</option>
                          {highestQulaificationList.map((qualification: any, index: number) => {
                            return (
                              <option value={qualification.highest_education}>{qualification.highest_education}</option>
                            )
                          })}
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.HIGHER_EDUCATION] &&
                            formik.errors[PROFESSIONAL_DETAILS.HIGHER_EDUCATION] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.HIGHER_EDUCATION]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Degree")}
                        </label>
                        <Field
                          as="select"
                          name={PROFESSIONAL_DETAILS.DEGREE}
                          className="email-input"
                          disabled={editable ? false : true}
                        >
                          <option value="">Please select degree type</option>
                          {degreeList?.map((qualification: any, index: number) => {
                            return (
                              <option value={qualification.highest_education}>{qualification.highest_education}</option>
                            )
                          })}
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.DEGREE] &&
                            formik.errors[PROFESSIONAL_DETAILS.DEGREE] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.DEGREE]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Degree Specialization")}
                        </label>
                        <Field
                          name={PROFESSIONAL_DETAILS.DEGREE_SUBJECT}
                          className="email-input"
                          placeholder={"Degree Specialization"}
                          maxLength={150}
                          disabled={editable ? false : true}
                        />

                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.DEGREE_SUBJECT] &&
                            formik.errors[PROFESSIONAL_DETAILS.DEGREE_SUBJECT] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.DEGREE_SUBJECT]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Specializations")}</label>
                        <Field
                          name={PROFESSIONAL_DETAILS.SKILLS}
                          className="email-input"
                          value={currentTag}
                          placeholder={t("Specializations")}
                          onKeyPress={(event: any) => {
                            handleKeyPress(event);
                          }}
                          onBlur={() => {
                            setSkillsTouched(true);
                          }}
                          onChange={(e: any) => {
                            setInputValue(e);
                          }}
                          disabled={editable ? false : true}
                        />
                        <img
                          className="plus-image"
                          src={plus}
                          onClick={onAddTag}
                        />
                      </div>
                      {/* <div className="errorMessage">
                        {((skillsList?.length === NUMBER_CONSTANTS.ZERO &&
                          skillsTouched === true) || (formSubmitted && skillsList?.length === NUMBER_CONSTANTS.ZERO)) && (
                            <p>
                              {t(
                                `${REGISTRATION_ERRORS.SKILLS}`
                              )}
                            </p>
                          )}
                      </div> */}
                      <div className="skills-list">
                        {skillsList?.map((skill: any, index: any) => {
                          return (
                            <Chip
                              className="skill-chip"
                              label={skill}
                              variant="outlined"
                              onDelete={handleDelete(index)}
                            />
                          );
                        })}
                      </div>

                    </div>
                  </div>



                  <div className="activity-wrapper">
                    <div className="row row-wrap">

                      <div className="col-md-6">

                        <div className="form-items">
                          <label className="form-label">
                            {t("Activities Offered")}
                          </label>
                          <Select
                            name={PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED}
                            value={selectedSubjects}
                            className="filter-select"
                            onChange={(e: any) => {
                              onSelectSubjects(e);
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.ACTIVITIES_OFFERED,
                                [e.target.value]
                              );
                            }

                            }
                          >
                            <MenuItem value={" "}>Please select activities offered </MenuItem>
                            {subjectList?.map((sub: any, index: any) => {
                              return (
                                <MenuItem value={sub}>
                                  {userType === `${NUMBER_CONSTANTS.FOUR}` ? sub.course_category_name : sub.category_name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <div className="errorMessage">
                            {subjectFormSubmitted && !selectedSubjects.id && (
                              <p>
                                {t(
                                  `Please select activities offered`
                                )}
                              </p>
                            )}

                          </div>
                        </div>

                      </div>
                      <div className="col-md-6">

                        <div className="form-items">
                          <label className="form-label">
                            {t("Mode of Teaching")}
                          </label>
                          <Select
                            // multiple
                            name={PROFESSIONAL_DETAILS.TEACHING_MODE}
                            value={modeOfTeching}
                            disabled
                            className="filter-select email-input teaching-mode"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.TEACHING_MODE,
                                e.target.value
                              );
                              setModeOfTeaching(e.target.value);
                            }}
                          >
                            {/* <MenuItem value="1">Online</MenuItem> */}
                            <MenuItem value="2">On-premises</MenuItem>
                          </Select>
                          {formSubmitted && !modeOfTeching && <div className="errorMessage">
                            <p>Please select mode of teaching</p>
                          </div>}
                        </div>
                      </div>
                    </div>
                    {
                      modeOfTeching == 2 && (
                        <div className="row row-wrap">
                          <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label ">
                                {t("State")}
                              </label>
                              <div className="">
                                <Autocomplete
                                  multiple
                                  componentName={PROFESSIONAL_DETAILS?.STATE}
                                  id="fixed-tags-demo"
                                  className="autocomplete-input"
                                  value={region}
                                  disableCloseOnSelect
                                  onChange={handleRegionChange}
                                  options={cityOptions}

                                  style={{
                                    borderRadius: '11.621px',
                                    background: '#ffffff',
                                    height: '50px',
                                    // width: '460px',
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="" placeholder="Add Address" />
                                  )}
                                />
                                <div className="errorMessage">
                                  {subjectFormSubmitted && locations?.length == 0 && (
                                    <p>
                                      {t(
                                        `Please enter State`
                                      )}
                                    </p>
                                  )}

                                </div>
                              </div>

                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label mandatory">
                                {t("Radius")}
                              </label>
                              <div className="">
                                <input
                                  name={PROFESSIONAL_DETAILS?.RADIUS}
                                  min={0}
                                  className="email-input"
                                  placeholder="Enter Radius" type="number"
                                  onChange={radiusHandleChange} />
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">{t("Years of Experience")}</label>
                          <Field
                            name={PROFESSIONAL_DETAILS.EXPERIENCE}
                            className="email-input"
                            placeholder={t("Years of Experience")}
                            maxlength={3}
                            value={experience}
                            onChange={(e: any) => {
                              onChangeExperience(e);
                              formik.setFieldValue(PROFESSIONAL_DETAILS.EXPERIENCE, experience)
                            }}
                          />

                        </div>
                        {experienceErrText && selectedSubjectsList && <div className="errorMessage">
                          <p>Please Enter Min expeience {selectedSubjectsList?.min_experience}</p>
                        </div>}
                        <div className="errorMessage">
                          {subjectFormSubmitted && experience == '' && (
                            <p>
                              {t(
                                `Please enter the expereince`
                              )}
                            </p>
                          )}

                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">{t("Expected Fee(AED)")}</label>
                          <Field
                            name={'Expected fee'}
                            className="email-input"
                            value={expectedFee}
                            placeholder={t("Expected Fee (AED)")}
                            onInput={numberOnly}
                            onPaste={numberOnly}
                            maxlength={6}
                            onChange={(e: any) => {
                              if (e.target.value <= parseInt(selectedSubjectsList?.max_price)) {
                                setExpectedFee(e.target.value)
                              }
                            }}
                          />
                        </div>
                        <div className="errorMessage">
                          {subjectFormSubmitted && expectedFee == '' && (
                            <p>
                              {t(
                                `Please enter the expected fee`
                              )}
                            </p>
                          )}

                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 add-btn-wrapper">
                        <button className="btn btn-primary add-btn" onClick={validateCategory}>Add</button>
                      </div>
                    </div>
                  </div>



                  <div className="row sub-exp-wrap">

                    {expSubject?.map((course: any, index: any) => {
                      return (


                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <div className="subject-detail-wrapper recreational " key={course.id}>
                            <div className="approval-label">
                              {course.status === 'approved' ? "Approved" : course.status === 'rejected' ? "Rejected" : "Approval Pending"}
                            </div>
                            <div className="rejected-label-icon">
                              {course.status === 'rejected' && <Tooltip title={course?.reason}><InfoOutlinedIcon style={{ fontSize: "16px" }} className="info-icon" /></Tooltip>}
                            </div>
                            <div className="session_slot_count_wrapper mt-1">
                              <div className="session_slot_count">
                                <div className="session-count">{course.experience}</div>
                                <div className="slot-text">Experience</div>
                              </div>

                            </div>
                            <div className="session_date_details_container mt-1">
                              <div className="session_subject">{course.activity}</div>
                              <div className="session_subject">{course.course_mode == "offline" ? "On-Premises" : course.course_mode}</div>
                              <div className="session_grade">{course.min}</div>
                              {course.isEdit === true && <div className="session_grade"><input value={course.expected_fee} onChange={(e: any) => {
                                let maxValue = subjectList.filter((sub: any, index: number) => {
                                  return sub.category_name === course.activity;
                                });
                                if (e.target.value <= parseInt(maxValue[0]?.max_price)) {
                                  onEditInput(course, e.target.value);
                                }
                                onEditInput(index, e.target.value);
                              }} />AED   <DoneIcon className="edit-icon" onClick={() => { onEditSubject(index) }} /></div>}
                              {!course.isEdit && <div className="session_grade">{course.expected_fee} AED {course.status !== 'approved' && <EditIcon className="edit-icon" onClick={() => { onEditSubject(index) }} />}</div>}
                            </div>
                            {course.status !== 'approved' && <div className="clear-icon-wrapper">
                              <ClearIcon className="clear-icon" onClick={() => { handleDeleteSubject(course.id) }} />
                            </div>}


                          </div>
                        </div>)


                    })
                    }
                  </div>

                  {location.pathname === ROUTES.PROFILE ?

                    <div className="bi-buttons-wrap">
                      {/*  <button
                          className="btn btn-back"
                          onClick={() => onNavigate(1)}
                        >
                          Back
                        </button> */}
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setFormSubmitted(true);
                          formik.handleSubmit();
                        }}
                      >
                        Update
                      </button>
                    </div>
                    : <div className="bi-buttons-wrap">
                      <button
                        className="btn btn-back"
                        onClick={() => onNavigate(1)}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setFormSubmitted(true);
                          formik.handleSubmit();
                        }}
                      >
                        Next
                      </button>
                    </div>}

                </div>
              );
            }}
          </Formik>


        </Card>
        <CategoryValidationDialog
          open={open}
          onClose={handleClose}
          message={categoryValidationMessage}
          update={putValidationCategory}
        />
      </div>
    </div>
  )
};

export default Recreational;